import React from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

function NotFound() {
	return (
		<Stack
			width="100%"
			height="calc(100vh - 50px)"
			alignItems="center"
			justifyContent="center"
			spacing={5}
		>
			<Typography textAlign="center" variant="h2" sx={{ color: 'black' }}>
				Empty Page
				
			</Typography>
			Select a page from the sidebar
			{/* <CusTomButton variant="outlined" onClick={() => navigate('/')}>
				Go Home
			</CusTomButton> */}
		</Stack>
	)
}

export default NotFound
